import execa from 'execa';
import { pipeStdout, watchStdout } from '../utils';
import { Task, TaskParameters } from './task';

export interface Indicators {
    end: string;
    watchStart: string;
    watchEnd?: string;
}

export interface CliTaskParameters extends TaskParameters {
    indicators: Indicators;
}

export abstract class CliTask extends Task {
    private readonly indicators: Indicators;

    constructor({ indicators, ...rest }: CliTaskParameters) {
        super(rest);
        this.indicators = indicators;
    }

    protected async runChildProcess(command: string, args: string[]) {
        const childProcess = execa(
            command,
            args,
            this.watch
                ? {
                      stdio: ['inherit', 'pipe', 'inherit'],
                  }
                : {
                      stdio: 'inherit',
                  }
        );

        if (!this.watch) {
            try {
                await childProcess;
            } finally {
                this.logCompletionResults(this.taskTimer.end());
            }
            return;
        }

        pipeStdout(childProcess);
        watchStdout(childProcess, this.indicators.watchStart, () => {
            this.taskTimer.start();
        });
        watchStdout(childProcess, this.indicators.end, () => {
            this.logCompletionResults(this.taskTimer.end());
        });
        watchStdout(childProcess, this.indicators.watchEnd, () => {
            this.logCompletionResults(this.taskTimer.end());
        });

        await childProcess;
    }
}
